import { useState } from 'react'
import { Box } from '@chakra-ui/react'

import { OfferSmeColumn } from './OfferSmeColumn'
import { ISelectedRisk, OfferGridProvider } from '../../../context/OfferGridContext'
import { OfferSmeHeaderColumn } from './OfferSmeHeaderColumn'
import { OfferCompleteness } from './OfferCompleteness'
import { OfferHeaderColumnWrapper } from './components/OfferHeaderColumnWrapper'
import { OffersGrid } from './components/OffersGrid'

export const OfferSmeGrid = ({ offerId }: { offerId: string }) => {
  const [openedColumns, setOpenedColumns] = useState<string[]>([])
  const [selectedRiskIds, setSelectedRiskIds] = useState<ISelectedRisk[]>([])
  const [isScrolled, setIsScrolled] = useState(false)

  const handleSectionTitleClick = (sectionId: string) => {
    let newColumns = []

    if (openedColumns.includes(sectionId)) {
      newColumns = openedColumns.filter((column) => column !== sectionId)
    } else {
      newColumns = [...openedColumns, sectionId]
    }

    setOpenedColumns(newColumns)
  }

  const handleIsScrolled = (isScrolled: boolean) => {
    setIsScrolled(isScrolled)
  }

  return (
    <OfferGridProvider
      openedColumns={openedColumns}
      onSectionTitleClick={handleSectionTitleClick}
      risks={selectedRiskIds}
      setRisks={setSelectedRiskIds}
    >
      <OffersGrid onIsScrolled={handleIsScrolled}>
        <OfferHeaderColumnWrapper isScrolled={isScrolled}>
          <OfferSmeHeaderColumn />
        </OfferHeaderColumnWrapper>

        {/* {smeOffers &&
          smeOffers.map(({ passed, offers }) => {
            return (
              <Box>
                <OfferCompleteness passed={passed} />

                <Box sx={{ display: 'flex', justifyContent: 'start' }}>
                  {offers.map((offer) => (
                    <OfferSmeColumn
                      key={offer.quoteId}
                      offerId={offerId}
                      status={String(offer.status)}
                      quoteId={String(offer.quoteId)}
                      company={offer.company}
                      validUntil={offer.validUntil}
                      passesAllParameters={offer.passesAllParameters}
                      smeInsurance={offer.smeInsurance}
                      // columnSections={columnSections}
                      columnSections={[]}
                      insuranceGroups={offer.insuranceGroups}
                    />
                  ))}
                </Box>
              </Box>
            )
          })} */}
      </OffersGrid>
    </OfferGridProvider>
  )
}
